import { Component, EventEmitter, Input, OnChanges, OnInit, OnDestroy, Output } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { DataTableSource } from '../../../classes/DataTableSource/datatablesource';

import { CollegeRecordNote, StudentCollegeInfo } from '../../../services/application/application.service';
import { DialogService } from '../../../services/dialogs/dialogs.service';
import { UserInfo } from '../../../services/user/user.service';

@Component({
    selector: 'app-request-notes',
    styleUrls: ['requestnotes.component.css'],
    templateUrl: 'requestnotes.component.html',
})
export class RequestNotesComponent implements OnChanges, OnInit, OnDestroy {
    // Inputs
    @Input() SelectedCollege: StudentCollegeInfo;
    @Input() SmallDisplay: boolean;
    @Input() StudentScheduleNotes: CollegeRecordNote[];
    @Input() User: UserInfo;

    // Outputs
    @Output() addnote: EventEmitter<void> = new EventEmitter<void>();
    @Output() removenote: EventEmitter<CollegeRecordNote> = new EventEmitter<CollegeRecordNote>();

    // Class
    AllHeaders: string[] = ['Date', 'Creator', 'Note', 'Actions'];
    NoData: boolean;
    NotesDataSource: DataTableSource<CollegeRecordNote>;
    VisibleColumns: string[];
    VisibleHeaders: string[];

    constructor(private dialogService: DialogService) {}

    ngOnDestroy() {}

    ngOnInit() {}

    ngOnChanges() {
        const self = this;

        let VisStudentScheduleNotes = (this.StudentScheduleNotes || []).filter(item => {
            return item.NoteVisible === true;
        });

        if (!VisStudentScheduleNotes.length) {
            this.NoData = true;
            VisStudentScheduleNotes = [{}];
        } else {
            this.NoData = false;
        }

        if (!this.NotesDataSource) {
            this.NotesDataSource = new DataTableSource<CollegeRecordNote>(VisStudentScheduleNotes);
        } else {
            this.NotesDataSource.Update(VisStudentScheduleNotes);
        }

        // If we have no notes, use that column.
        if (self.NoData) {
            this.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            this.VisibleColumns = ['NoData'];
        } else {
            // Only include the actions column if this is not a historical record.
            if (self.SmallDisplay) {
                this.VisibleHeaders = ['SmallDisplay'];
                this.VisibleColumns = ['SmallDisplay'];
            } else {
                this.VisibleHeaders = this.AllHeaders.slice();

                if (this.SelectedCollege && this.SelectedCollege.HistoricalRecord !== true) {
                    this.VisibleColumns = this.AllHeaders.slice();
                } else {
                    this.VisibleColumns = this.AllHeaders.slice(0, this.AllHeaders.length - 1);
                }
            }
        }
    }

    // #region Add Note Method

    AddNote() {
        this.addnote.emit();
    }

    // #endregion

    // #region Remove Note Method

    RemoveNote(note: CollegeRecordNote) {
        if (!note) {
            return;
        }

        this.removenote.emit(note);
    }

    // #endregion
}

// #region Custom Classes

// #endregion



// WEBPACK FOOTER //
// ./src/app/ui/requestnotes/requestnotes.component.ts